import { useForm, useFormContext } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { fullSchema } from "./form-validation/full-form.schema";
import type { StudentOnboardingFormInputs } from "./form-validation/full-form.schema";
import { defaultValues, formatFormDataToOnboardStudentBody } from "./form-validation/shared";
import { Button } from "@shared-kernel/primary/shared/shadcn/ui/button";
import { Form } from "@shared-kernel/primary/shared/shadcn/ui/form";
import { ProfileStep } from "./subforms/student-onboarding.profile.subform";

interface Props {
  onSubmit: (body: ReturnType<typeof formatFormDataToOnboardStudentBody>) => void;
  submitting: boolean;
}

export const StudentOnboarding = (props: Props) => {
  const methods = useForm<StudentOnboardingFormInputs>({
    resolver: yupResolver(fullSchema),
    defaultValues,
    mode: "onSubmit",
  });

  return (
    <Form {...methods}>
      <StudentOnboardingBody {...props} />
    </Form>
  );
};

const StudentOnboardingBody = ({ onSubmit, submitting }: Props) => {
  const { handleSubmit } = useFormContext<StudentOnboardingFormInputs>();

  const handleConfirm = handleSubmit(data => {
    onSubmit(formatFormDataToOnboardStudentBody(data));
  });

  return (
    <form onSubmit={handleConfirm} className="space-y-6">
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">Renseignez votre nom de scène pour finaliser la création de votre profil élève.</p>
      </div>
      <ProfileStep />
      <div className="flex justify-end">
        <Button type="submit" disabled={submitting} className="w-full sm:w-auto">
          Confirmer
        </Button>
      </div>
    </form>
  );
};
